import { FacetModel } from "./facet.model";

export interface Facet {
  id: number;
  alias: FacetAlias;
  name: string;
}

export interface UserFacet extends Facet {
  count: number;
  description: string;
  units?: FacetModel[] | null;
}

export enum FacetAlias {
  chapter = 'chapter',
  house = 'house',
  car = 'car',
  bestFriend = 'bestFriend',
  education = 'education',
  employment = 'employment',
  family = 'family',
  music = 'music',
  pet = 'pet',
  sport = 'sport',
  vacation = 'vacation',
}

export enum FacetAliasId {
  chapter = 1,
  house,
  car,
  bestFriend,
  education,
  employment,
  family,
  music,
  pet,
  sport,
  vacation,
}

export enum FacetAliasNames {
  chapter = 'Chapter',
  house = 'Home',
  car = 'Car',
  bestFriend = 'Best friend',
  education = 'Education',
  employment = 'Employment',
  family = 'Family member',
  music = 'Music',
  pet = 'Pet',
  sport = 'Sport',
  vacation = 'Vacation',
}

export enum FacetAliasNamesPlural {
  chapter = 'Chapters',
  house = 'Home',
  car = 'Cars',
  bestFriend = 'Best friends',
  education = 'Educations',
  employment = 'Employments',
  family = 'Family members',
  music = 'Musics',
  pet = 'Pets',
  sport = 'Sports',
  vacation = 'Vacations',
}

export enum FacetId {
  chapter = 1,
}
